<template>
  <div>
    <multiselect
      v-model="value"
      :options="options"
      searchable="true"
      placeholder="Select Site"
      @change="onChange($event)"
    ></multiselect>
  </div>
</template>

<script>
import Multiselect from "@vueform/multiselect";
import api from "@/api/index";
import { mapState } from "vuex";

export default {
  components: {
    Multiselect,
  },
  props: {
    company: {
      type: Object,
    },
    site: {
      type: Object,
    },
  },
  data() {
    return {
      value: null,
      sites: [],
      groups: [],
    };
  },
  watch: {
    company() {
      this.getSites();
    },
    site(value) {
      this.value = value;
    },
  },
  computed: {
    options() {
      return this.sites.map((f) => {
        return {
          label: f.name,
          value: { label: f.name, value: f.siteGuid },
        };
      });
    },
  },
  methods: {
    async getSites() {
      const guid = this.company
        ? this.company.companyGuid
          ? this.company.companyGuid
          : this.company.value
        : "69093552-3e6c-45cd-9332-942babf5c32e";
      const res = await api.sites.getByCompanyGuid(guid);
      this.sites = res.data.entityData;
    },
    onChange(e) {
      this.$emit("input", e);
      this.$emit("change", e);
      if (e) {
        this.getGroups(e.value);
      }
    },
    async getGroups(guid) {
      const res = await api.groups.getSiteGroups(guid);
      this.groups = res.data.entityData;
      this.$emit("groupLoaded", this.groups);
    },
  },
  async created() {
    await this.getSites();
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>

<style lang="scss" scoped></style>
